"use client";

import React from "react";
import { Plane } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
const airports = [{
  code: "JFK",
  name: "John F. Kennedy International Airport"
}, {
  code: "LGA",
  name: "LaGuardia Airport"
}, {
  code: "EWR",
  name: "Newark Liberty International Airport"
}, {
  code: "BDL",
  name: "Bradley International Airport"
}, {
  code: "HPN",
  name: "Westchester County Airport"
}, {
  code: "TEB",
  name: "Teterboro Airport"
}];
export default function AirportTransferExpertise() {
  return <section className="relative bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {}
          <div className="relative order-2 lg:order-1">
            <div className="relative aspect-[4/3] rounded-lg overflow-hidden shadow-medium">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/airport_runway_aerial_view.png" alt="Aerial view of airport runway" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent" />
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2">
            <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
              Airport Transfer Expertise
            </h2>
            <p className="text-lg text-muted mb-8">
              We service major airports across the region with reliable,
              punctual luxury transportation.
            </p>

            <div className="space-y-4">
              {airports.map((airport, i) => <AirportItem key={airport.code} airport={airport} index={i} data-index={i} />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}
interface AirportItemProps {
  airport: {
    code: string;
    name: string;
  };
  index: number;
  "data-index": number;
}
function AirportItem({
  airport,
  index,
  "data-index": dataIndex
}: AirportItemProps) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const delay = index * 100;
  return <div ref={ref} data-index={dataIndex} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
    transitionDelay: isVisible ? `${delay}ms` : "0ms"
  }}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="card group cursor-pointer p-4 flex items-center gap-4 hover:bg-secondary-hover hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
            <div className="w-12 h-12 rounded-lg bg-primary-light/10 flex items-center justify-center group-hover:bg-accent group-hover:shadow-medium transition-all duration-[var(--duration-medium)]">
              <Plane className="w-6 h-6 text-foreground-secondary group-hover:text-foreground-accent transition-colors duration-[var(--duration-medium)]" />
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-display font-semibold text-foreground-secondary group-hover:text-accent transition-colors duration-[var(--duration-medium)]">
                {airport.code}
              </h3>
              <p className="text-sm text-muted group-hover:text-foreground-secondary transition-colors duration-[var(--duration-medium)]">
                {airport.name}
              </p>
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent side="right" className="max-w-xs">
          <p className="text-xs">
            Premium car service to and from {airport.name}
          </p>
        </TooltipContent>
      </Tooltip>
    </div>;
}